// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb{display:flex;flex-direction:row}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb.awsccc-u-sb-v{flex-direction:column}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb.awsccc-u-sb-xxs{gap:4px}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb.awsccc-u-sb-xs{gap:8px}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb.awsccc-u-sb-s{gap:12px}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-sb.awsccc-u-sb-m{gap:16px}", ""]);
// Exports
module.exports = exports;
